import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, color = "primary" }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'bg-success/10 text-success border-success/20';
      case 'warning':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'error':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-primary/10 text-primary border-primary/20';
    }
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-3 sm:p-4 lg:p-6 shadow-card hover:shadow-modal transition-hover w-full min-w-0">
      <div className="flex items-center justify-between mb-2 sm:mb-3 lg:mb-4">
        <div className={`w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 rounded-lg flex items-center justify-center border flex-shrink-0 ${getColorClasses()}`}>
          <Icon name={icon} size={16} className="sm:hidden" />
          <Icon name={icon} size={20} className="hidden sm:block lg:hidden" />
          <Icon name={icon} size={24} className="hidden lg:block" />
        </div>
        {change && (
          <div className={`flex items-center space-x-1 flex-shrink-0 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={12} className="sm:hidden" />
            <Icon name={getChangeIcon()} size={14} className="hidden sm:block lg:hidden" />
            <Icon name={getChangeIcon()} size={16} className="hidden lg:block" />
            <span className="text-xs sm:text-sm font-medium">{change}</span>
          </div>
        )}
      </div>
      <div className="min-w-0">
        <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-foreground mb-0.5 sm:mb-1 truncate">{value}</h3>
        <p className="text-xs sm:text-sm text-muted-foreground truncate">{title}</p>
      </div>
    </div>
  );
};

export default MetricCard;